export const DRAG_CREATING_LINK_TOOL_NAME = 'DragCreatingLinkTool';
export const IS_FAKE_DRAG_CREATE_PORT_PROP = 'isFakeDragCreatePort';
